import { useState } from 'react'
import { ItemToRestock } from 'src/features/restocking/RestockingTypes'
import { Typography } from '@mui/material'
import { ExpandMore, ExpandLess } from '@mui/icons-material'
import RestockingBatchesTable from '../RestockingBatchesTable/RestockingBatchesTable'
import theme from 'src/styles/theme'
import * as S from './CardRestockProduct.styles'

interface CardRestockProductProps {
  product: ItemToRestock
}

const CardRestockProduct: React.FC<CardRestockProductProps> = ({ product }) => {
  const [expanded, setExpanded] = useState(false)

  const handleExpand = () => {
    setExpanded(!expanded)
  }

  const calculateTotalQuantity = () =>
    product.batches.reduce((total, batch) => total + batch.quantity, 0)

  return (
    <S.Container data-testid='card-restock-product-test-id'>
      <S.Row>
        <S.Column>
          <Typography variant='subtitle1'>Descrição</Typography>
          <Typography fontWeight={700}>{product.description}</Typography>
        </S.Column>
      </S.Row>
      <S.Row>
        <S.Column width='65%'>
          <Typography variant='subtitle1'>Quantidade total</Typography>
          <S.CounterTooltip
            title='Quantidade total, somando todos os lotes'
            placement='top'
            arrow
          >
            <Typography fontWeight={700}>{calculateTotalQuantity()}</Typography>
          </S.CounterTooltip>
        </S.Column>
        <S.Column width='35%' center>
          <Typography variant='subtitle1'>
            {expanded ? 'Ocultar lotes' : 'Mostrar lotes'}
          </Typography>
          {
            expanded
              ? <ExpandLess onClick={handleExpand} data-testid='expand-less-test-id'/>
              : <ExpandMore onClick={handleExpand} data-testid='expand-more-test-id'/>
          }
        </S.Column>
      </S.Row>
      {
        expanded && (
        <RestockingBatchesTable
          batches={product.batches}
          color={theme.colors.black}
          width='100%'
        />
        )
      }
    </S.Container>
  )
}

export default CardRestockProduct
